/**
 * Generated from ch8_p03.fla
 */
export function ch8_p03(this: Ich8_p03) {
	const bg = this.bg;
	ch8_p03_hh_ch8_72dpi_p03psdAssetchp8_p03_bg.call(this.bg);
	bg.x = 832;
	bg.y = 384;
	bg.width = 1664.00;
	bg.height = 768.00;
	bg.alpha = 1.00;
	if (bg.onLayout) bg.onLayout();
	const lamb = this.lamb;
	ch8_p03_hh_ch8_72dpi_p03psdAssetchp8_p03_lamb.call(this.lamb);
	lamb.x = 995;
	lamb.y = 212.25;
	lamb.width = 278.00;
	lamb.height = 185.50;
	lamb.alpha = 1.00;
	if (lamb.onLayout) lamb.onLayout();
	const treeTop = this.treeTop;
	ch8_p03_hh_ch8_72dpi_p03psdAssetchp8_p03_treetop.call(this.treeTop);
	treeTop.x = 886.5;
	treeTop.y = 100;
	treeTop.width = 633.00;
	treeTop.height = 200.00;
	treeTop.alpha = 1.00;
	if (treeTop.onLayout) treeTop.onLayout();
	const holly = this.holly;
	ch8_p03_hh_ch8_72dpi_p03psdAssetchp8_p03_holly.call(this.holly);
	holly.x = 584.5;
	holly.y = 354;
	holly.width = 438.00;
	holly.height = 534.00;
	holly.alpha = 1.00;
	if (holly.onLayout) holly.onLayout();
	const grass = this.grass;
	ch8_p03_hh_ch8_72dpi_p03psdAssetchp8_p03_grass.call(this.grass);
	grass.x = 726.25;
	grass.y = 638;
	grass.width = 1452.50;
	grass.height = 260.00;
	grass.alpha = 1.00;
	if (grass.onLayout) grass.onLayout();
	const bushes = this.bushes;
	ch8_p03_hh_ch8_72dpi_p03psdAssetchp8_p03_bushes.call(this.bushes);
	bushes.x = 832;
	bushes.y = 521;
	bushes.width = 1664.00;
	bushes.height = 494.00;
	bushes.alpha = 1.00;
	if (bushes.onLayout) bushes.onLayout();
	const frameRight = this.frameRight;
	ch8_p03_hh_ch8_72dpi_p03psdAssetchp8_p03_wcframeRframe.call(this.frameRight);
	frameRight.x = 1664;
	frameRight.y = 384;
	frameRight.width = 351.00;
	frameRight.height = 768.00;
	frameRight.alpha = 1.00;
	if (frameRight.onLayout) frameRight.onLayout();
	const linesRight = this.linesRight;
	ch8_p03_hh_ch8_72dpi_p03psdAssetchp8_p03_wcframerlines.call(this.linesRight);
	linesRight.x = 1664;
	linesRight.y = 258.5;
	linesRight.width = 153.50;
	linesRight.height = 517.00;
	linesRight.alpha = 1.00;
	if (linesRight.onLayout) linesRight.onLayout();
	const frameLeft = this.frameLeft;
	ch8_p03_hh_ch8_72dpi_p03psdAssetchp8_p03_wcframeLframe.call(this.frameLeft);
	frameLeft.x = 0;
	frameLeft.y = 384;
	frameLeft.width = 345.50;
	frameLeft.height = 768.00;
	frameLeft.alpha = 1.00;
	if (frameLeft.onLayout) frameLeft.onLayout();
	const linesLeft = this.linesLeft;
	ch8_p03_hh_ch8_72dpi_p03psdAssetchp8_p03_wcframellines.call(this.linesLeft);
	linesLeft.x = 0;
	linesLeft.y = 394.25;
	linesLeft.width = 136.50;
	linesLeft.height = 632.50;
	linesLeft.alpha = 1.00;
	if (linesLeft.onLayout) linesLeft.onLayout();
	return this;
}
function ch8_p03_hh_ch8_72dpi_p03psdAssetchp8_p03_bg(this: Ich8_p03_hh_ch8_72dpi_p03psdAssetchp8_p03_bg) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp8_p03_bg", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch8_p03_hh_ch8_72dpi_p03psdAssetchp8_p03_lamb(this: Ich8_p03_hh_ch8_72dpi_p03psdAssetchp8_p03_lamb) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp8_p03_lamb", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch8_p03_hh_ch8_72dpi_p03psdAssetchp8_p03_treetop(this: Ich8_p03_hh_ch8_72dpi_p03psdAssetchp8_p03_treetop) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp8_p03_treetop", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch8_p03_hh_ch8_72dpi_p03psdAssetchp8_p03_holly(this: Ich8_p03_hh_ch8_72dpi_p03psdAssetchp8_p03_holly) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp8_p03_holly", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch8_p03_hh_ch8_72dpi_p03psdAssetchp8_p03_grass(this: Ich8_p03_hh_ch8_72dpi_p03psdAssetchp8_p03_grass) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp8_p03_grass", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch8_p03_hh_ch8_72dpi_p03psdAssetchp8_p03_bushes(this: Ich8_p03_hh_ch8_72dpi_p03psdAssetchp8_p03_bushes) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp8_p03_bushes", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch8_p03_hh_ch8_72dpi_p03psdAssetchp8_p03_wcframeRframe(this: Ich8_p03_hh_ch8_72dpi_p03psdAssetchp8_p03_wcframeRframe) {
	if (this.setLayoutTexture) this.setLayoutTexture("Rframe", 1.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("screen");
	return this;
}
function ch8_p03_hh_ch8_72dpi_p03psdAssetchp8_p03_wcframerlines(this: Ich8_p03_hh_ch8_72dpi_p03psdAssetchp8_p03_wcframerlines) {
	if (this.setLayoutTexture) this.setLayoutTexture("rlines", 1.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch8_p03_hh_ch8_72dpi_p03psdAssetchp8_p03_wcframeLframe(this: Ich8_p03_hh_ch8_72dpi_p03psdAssetchp8_p03_wcframeLframe) {
	if (this.setLayoutTexture) this.setLayoutTexture("Lframe", 0.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("screen");
	return this;
}
function ch8_p03_hh_ch8_72dpi_p03psdAssetchp8_p03_wcframellines(this: Ich8_p03_hh_ch8_72dpi_p03psdAssetchp8_p03_wcframellines) {
	if (this.setLayoutTexture) this.setLayoutTexture("llines", 0.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
interface Ich8_p03Array<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface Ich8_p03Container {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface Ich8_p03Sprite extends Ich8_p03Container {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
	alpha: number;
	setBlendMode?(blendMode: string): void;
}
interface Ich8_p03Text extends Ich8_p03Container {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface Ich8_p03Polygon extends Array<number> {
}
interface Ich8_p03 {
	readonly bg: Ich8_p03_hh_ch8_72dpi_p03psdAssetchp8_p03_bg;
	readonly lamb: Ich8_p03_hh_ch8_72dpi_p03psdAssetchp8_p03_lamb;
	readonly treeTop: Ich8_p03_hh_ch8_72dpi_p03psdAssetchp8_p03_treetop;
	readonly holly: Ich8_p03_hh_ch8_72dpi_p03psdAssetchp8_p03_holly;
	readonly grass: Ich8_p03_hh_ch8_72dpi_p03psdAssetchp8_p03_grass;
	readonly bushes: Ich8_p03_hh_ch8_72dpi_p03psdAssetchp8_p03_bushes;
	readonly frameRight: Ich8_p03_hh_ch8_72dpi_p03psdAssetchp8_p03_wcframeRframe;
	readonly linesRight: Ich8_p03_hh_ch8_72dpi_p03psdAssetchp8_p03_wcframerlines;
	readonly frameLeft: Ich8_p03_hh_ch8_72dpi_p03psdAssetchp8_p03_wcframeLframe;
	readonly linesLeft: Ich8_p03_hh_ch8_72dpi_p03psdAssetchp8_p03_wcframellines;
}
interface Ich8_p03_hh_ch8_72dpi_p03psdAssetchp8_p03_bg extends Ich8_p03Sprite {
}
interface Ich8_p03_hh_ch8_72dpi_p03psdAssetchp8_p03_lamb extends Ich8_p03Sprite {
}
interface Ich8_p03_hh_ch8_72dpi_p03psdAssetchp8_p03_treetop extends Ich8_p03Sprite {
}
interface Ich8_p03_hh_ch8_72dpi_p03psdAssetchp8_p03_holly extends Ich8_p03Sprite {
}
interface Ich8_p03_hh_ch8_72dpi_p03psdAssetchp8_p03_grass extends Ich8_p03Sprite {
}
interface Ich8_p03_hh_ch8_72dpi_p03psdAssetchp8_p03_bushes extends Ich8_p03Sprite {
}
interface Ich8_p03_hh_ch8_72dpi_p03psdAssetchp8_p03_wcframeRframe extends Ich8_p03Sprite {
}
interface Ich8_p03_hh_ch8_72dpi_p03psdAssetchp8_p03_wcframerlines extends Ich8_p03Sprite {
}
interface Ich8_p03_hh_ch8_72dpi_p03psdAssetchp8_p03_wcframeLframe extends Ich8_p03Sprite {
}
interface Ich8_p03_hh_ch8_72dpi_p03psdAssetchp8_p03_wcframellines extends Ich8_p03Sprite {
}
